module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n    <div fxFlex fxLayout=\"column\" fxLayoutAlign=\"space-between\">\r\n        <div>\r\n            <img src=\"assets/images/business-32.png\" />\r\n            <label class=\"title\">חוזים</label>\r\n        </div>\r\n        <div fxLayout=\"column\" fxLayoutAlign=\"start center\" fxFlex=\"95\" fxFlex.xs=\"100\">\r\n            <app-deals-grid></app-deals-grid>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deals/deals-page/deals-page.component.html
// module id = ./src/app/components/deals/deals-page/deals-page.component.html
// module chunks = main